import { MicroServiceCall } from '../microservices';

const ms = new MicroServiceCall();

export default ms;
